import type { FaireProductEntity } from "../../entity_types/product";

export const p_axch9725qf: FaireProductEntity = {
  token: "p_axch9725qf",
  type: "product",
  name: "Spooky Sweet Halloween Graphic Sweatshirt",
  brandToken: "b_7t2qf2f5h6",
  brandName: "IVE",
  imageUrl:
    "https://cdn.faire.com/fastly/fa7961d1eff8557aebeb34ccf87c75c449a821f48eb14bbe78515be5bcfaf79f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03001a1273182ec26f0eb8200d4bff5b07c0417d1b35e508c2d65c8dfd54421d.jpeg",
    "https://cdn.faire.com/fastly/c933f41f79d118a15f4e3a4a56826c2a38aef94b710717c12207b530ec1d0853.jpeg",
    "https://cdn.faire.com/fastly/1631ec0f2739039a60c10081a3d32e694b99ebfe7516c6ed1d7d0346121c7ad0.jpeg",
    "https://cdn.faire.com/fastly/0fbe495354b6ac54f3d3d8c82fa6f188d1a922643cfde8c6553a236337e9778a.jpeg",
    "https://cdn.faire.com/fastly/8ac8136735a0c6fbc0dd5750a603007d0f69b479622101764186dfda560cf05b.jpeg",
  ],
  priceDollars: 35.92,
  description:
    "LovLov Style Clothing\n\nTop Features:\n🍂 Classic autumn inspired playful, festive aesthetic\n👚 Chic long sleeve sweatshirt silhouette featuring a comfortable, everyday neckline\n🎃 Intricate Halloween graphic detailing combining spooky motifs with a charming, sweet twist\n☁️ Premium ultra-soft fleece or terry fabrication for optimal warmth and luxury comfort\n📐 Comfortable loose fit body construction with a relaxed drape for a laid-back profile\n👕 True to size loose, effortless fit\n\nLovLov, Final Touch, Very J, Love Tree , PETRA 153, Sage + Fig , Azura, Codigo , QmP Moda Clothing\n\nKeywords :Women Clothing, Apparel, Western Apparel, jeans, denim, Jacket, Shacket, sweater, Maxi dress, Young contemporary, Missy, Dress top, Plus sizes womens clothing, Sets, Boho clothing, Linen clothing , Romper, Jumpsuit , Tops, western apparel, linen dress , summer dress, kimono, Floral dress, Gingham , Maxi skirt , summer tops , Mini dress , Dresses for women Spring, swimwear, linen , wedding guest dress, white dress\n\n",
  tags: [],
  msrpDollars: 71.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:42.253Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
